import { render, staticRenderFns } from "./DeviceItem.vue?vue&type=template&id=4943822e"
import script from "./DeviceItem.vue?vue&type=script&lang=js"
export * from "./DeviceItem.vue?vue&type=script&lang=js"
import style0 from "./DeviceItem.vue?vue&type=style&index=0&id=4943822e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports